












import { defineComponent, onMounted, ref } from "@vue/composition-api";
import useOnboarding from "@/hooks/useOnboarding";
import { OnboardingNames } from "@/hooks/useOnboarding/const";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "FundraisingGoalsSetup",
  components: { BaseConfirm, BaseIconButton, BaseButton },
  setup() {
    const show = ref(false);
    const { show: needShow, complete } = useOnboarding(OnboardingNames.FUNDRAISING_GOALS);

    const steps = [
      $t("Set title and amount for your goal"),
      $t("Specify the conditions for completion"),
      $t("Add rewards to engage your audience"),
    ];

    const onClick = () => {
      complete();
      show.value = false;
    };

    onMounted(() => {
      show.value = needShow.value;
    });

    return {
      steps,
      show,
      onClick,
    };
  },
});
